angular.module('impactx.panel').controller('TenderPanelCtrl', [
    'TranslationService',
    '$redirect',
    'ThemeWorldService',
    'panelService',
    '$context',
    'AppConfiguration',
    'ProductViewService',
    'SearchFilterStorage',
    '$routeParams',
    TenderPanelCtrl]);

function TenderPanelCtrl(TranslationService, $redirect, ThemeWorldService, panelService, $context, AppConfiguration, ProductViewService,
                         SearchFilterStorage, $routeParams) {
    var self = this;
    if(!self.trns) {
        self.trns = {};
    }
    self.trns = {
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        addToProductView: TranslationService.get('addToProductView'),
        removeFromProductView: TranslationService.get('removeFromProductView')
    };

    self.getTenderPanelColor = panelService.getTenderPanelColor;

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');

    self.redirectToTender = function() {
        if ($routeParams.useSetFilterList && SearchFilterStorage.getCurrentFilter()) {
            var filter = JSON.parse(JSON.stringify(SearchFilterStorage.getCurrentFilter()));
            filter.tenderId = {value: self.tender.id};
            filter.dialogFilter = "tender";
            SearchFilterStorage.setTenderFilter(self.tender.id, filter);
            $redirect.redirectTo(null, "tender/" + self.tender.id + "/true");
        }
        else {
            if (self.currentFilter) {
                var filter = JSON.parse(JSON.stringify(self.currentFilter));
                filter.tenderId = {value: self.tender.id};
                filter.dialogFilter = "tender";
                filter.productPageNumber = 0;
                SearchFilterStorage.setTenderFilter(self.tender.id, filter);
            }
            if(impactX.isDefined(self, "tender.id")){
                $redirect.redirectTo(null, "/tender/" + self.tender.id + (self.currentFilter ? "/true" : ""));
            }
        }
    };

    self.addToThemeWorld = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addTendersToThemeWorld([self.tender]);
    };

    self.removeFromThemeWorld = function($event) {
        var tenderIds = [];
        self.tender.tw.add = true;
        self.tender.tw.remove = false;
        tenderIds.push(self.tender.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeTendersFromThemeWorld($context.hasActiveThemeWorld.id, tenderIds);
    };

    self.addToProductView = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addTendersToProductView([self.tender]);
    };

    self.removeFromProductView = function($event) {
        var tenderIds = [];
        self.tender.pv.add = true;
        self.tender.pv.remove = false;
        tenderIds.push(self.tender.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeTendersFromProductView($context.hasActiveProductView.id, tenderIds);
    };
}
